import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "~/atoms/popover";

interface Props {
  trigger: React.ReactNode;
  onConfirm: (e: React.MouseEvent) => void;
}

export const ConfirmDeletePopover = ({ trigger, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className="grid w-80 grid-cols-2 gap-2">
        <p className="col-span-2 text-sm">{t("commons.deleteConfirm")}</p>
        <PopoverClose asChild>
          <Button variant="outline" size="sm">
            {t("commons.buttons.cancel")}
          </Button>
        </PopoverClose>
        <Button variant="destructive" size="sm" onClick={onConfirm}>
          {t("commons.buttons.confirm")}
        </Button>
      </PopoverContent>
    </Popover>
  );
};
